module.exports = __webpack_public_path__ + "static/media/success-checkmark.865767f2.svg";